<template>
    <div class="tile">
        <div :id="`${link}-tile-link`" style="margin-top: -110px;float: left;"></div>
        <div class="tile__header">
            <slot name="tileHeader" />
        </div>
        <div class="tile__content">
            <slot name="tileContent" />
        </div>
        <div class="tile__footer">
            <slot name="tileFooter" />
        </div>
    </div>
</template>

<script>

export default {
    props: ['link']
}
</script>

<style lang="sass" scoped>
.tile
    background: #fff
    border-color: #fff
    position: relative
    overflow: hidden
    box-shadow: 1px 2px 4px rgba(0, 0, 0, .4)
    padding: 15px
    color: #444
    border: 1px solid #ddd
    &:hover
        border: 1px solid #c5c5c5
        box-shadow: 2px 3px 4px rgba(0, 0, 0, .5)
    &__header
        width: 100%
        border-bottom: solid 1px #ebe7ed
        padding-bottom: 10px
</style>